import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';
import { SalesMasterData, SalesMaster } from '../../../interfaces/masters/salesmaster';
import { SalesMasterApi } from '../api/salesmaster.api';
@Injectable() 
export class SalesMasterService extends SalesMasterData{
 
  constructor(private api: SalesMasterApi) {
    super();
  } 
  
  getall(url: string): Observable<SalesMaster[]> { 
    return this.api.getall(url);
  } 

  getById(url:string): Observable<SalesMaster>{
      return this.api.getby_id(url);
  }

  create(url: string, data:SalesMaster): Observable<SalesMaster[]> {
    return this.api.add(url,data);
  }

  update(url: string, data:SalesMaster): Observable<SalesMaster> { 
    return this.api.update(url,data);
  }  

  list(url: string): Observable<any> {
    return this.api.list(url);
  }
  searchList(url: string,data:any): Observable<any> {
     
      return this.api.searchList(url,data);
    }
    
    //Sales Report For MultiBranch
    searchForMultiBranch(url: string,data:any): Observable<any> {
      return this.api.searchList(url,data);
    }
}
